<template>
  <a v-if="href" :href="href" class="app-next-link" title="Open the new Drive Scout app" data-testid="app-next-link"
    @click="handOff" @auxclick="openGate">
    New App
  </a>
</template>

<script>
import { Config } from "../../../../../DriveScout/Config.js";
import { getAuthToken } from "../../../../../DriveScout/API/core/HttpClient.js";

// The new app's address for each host this app runs on. Production has no row on
// purpose: the link stays hidden until app-next opens for public use, and adding
// "https://app.drivescout.com": "https://app-next.drivescout.com" is what opens it.
const APP_NEXT_URL_BY_ORIGIN = Object.freeze({
  "https://app.drivescout.local.drivescout.build":
    "https://app-next.drivescout.local.drivescout.build",
  "https://dev.drivescout.com": "https://app-next-dev.drivescout.com",
});

// app-next's nginx skips its basic-auth prompt when this cookie holds
// APP_NEXT_GATE_PASS (drivescout-vue3 docker/production/basic-auth.sh). A browser
// can't attach an Authorization header to a link click, so a cookie on the parent
// domain both hosts share is how the pass travels.
const GATE_COOKIE_NAME = "ds_app_next_pass";
const GATE_COOKIE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60;

// The fragment app-next reads and strips before its router starts
// (drivescout-vue3 src/auth/token.ts consumeUrlToken).
const HANDOFF_TOKEN_PARAM = "ds_token";

// The same parent-domain rule as AuthService's cookieConfig.
function sharedCookieDomain() {
  return "." + window.location.hostname.split(".").slice(-2).join(".");
}

// Only an unmodified primary click hands the session over. Middle, ctrl/cmd and
// shift clicks open the plain href somewhere else, and a new tab must not get a
// bearer in its URL.
function isPlainLeftClick(event) {
  return (
    !event.defaultPrevented &&
    event.button === 0 &&
    !event.ctrlKey &&
    !event.metaKey &&
    !event.shiftKey &&
    !event.altKey
  );
}

export default {
  name: "AppNextLink",
  computed: {
    href() {
      return APP_NEXT_URL_BY_ORIGIN[window.location.origin];
    },
  },
  methods: {
    openGate() {
      if (!Config.APP_NEXT_GATE_PASS) {
        return;
      }
      document.cookie =
        `${GATE_COOKIE_NAME}=${Config.APP_NEXT_GATE_PASS}; ` +
        `Domain=${sharedCookieDomain()}; Path=/; ` +
        `Max-Age=${GATE_COOKIE_MAX_AGE_SECONDS}; Secure; SameSite=Lax`;
    },
    // Without a token, or on any other kind of click, the browser follows the
    // plain href and app-next shows its own login.
    handOff(event) {
      this.openGate();

      const token = getAuthToken();
      if (!isPlainLeftClick(event) || !token) {
        return;
      }

      event.preventDefault();
      const fragment = new URLSearchParams({ [HANDOFF_TOKEN_PARAM]: token });
      window.location.assign(`${this.href}/#${fragment}`);
    },
  },
};
</script>

<style scoped>
.app-next-link {
  display: inline-block;
  margin-right: 8px;
  padding: 3px 8px;
  border: 1px solid #ffffff;
  border-radius: 3px;
  color: #ffffff;
  font-size: 12px;
  white-space: nowrap;
}

.app-next-link:hover,
.app-next-link:focus {
  color: #ffffff;
  opacity: 0.8;
  text-decoration: none;
}
</style>
